wbApp.controller('ScheduleCtrl', ['$scope', '$modal', '$filter', '$translate', '$q',
    'classroomSvc', 'semesterSvc', 'tenantSettingSvc', 'securitySvc',
    'messageBoxSvc', 'courseScheduleSvc', 'employeeSvc',
function ($scope, $modal, $filter, $translate, $q,
    classroomSvc, semesterSvc, tenantSettingSvc, securitySvc,
    messageBoxSvc, courseScheduleSvc, employeeSvc) {

    var lastStartDate = moment().startOf('isoWeek').toDate();
    var lastEndDate = moment(lastStartDate).add(7, 'day').startOf('day').toDate();
    
    var employees = [] 
    employeeSvc.getAllAsync().$promise.then(function(e) {
        employees = e;
    });

    semesterSvc.getDefaultAsync()
        .then(function (semester) {
            $scope.semesterID = semester.id;
            loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
        });

    $scope.$on('refreshData', function (e, data) {
        if ($scope.semesterID) {
            loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
        }
    });

    $scope.onSemesterChange = function (semesterID) {
        if (semesterID) {           
            $scope.semesterID = semesterID;
            loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
        }
    };

    $scope.onDateChanged = function (startDate, endDate) {
        if (Date.prototype.isValidDate(startDate) && Date.prototype.isValidDate(endDate)) {
            loadSemesterSchedule($scope.semesterID, startDate, endDate);
        }
    }

    function loadSemesterSchedule(semesterID, startDate, endDate) {
        if (!Date.prototype.isValidDate(startDate) || !Date.prototype.isValidDate(endDate)) {
            return;
        }

        lastStartDate = startDate;
        lastEndDate = endDate;

        $scope.isBusy = true;

        courseScheduleSvc.getAllForSemesterAllAsync(
            semesterID,
            null, // compensationGroupID
            null, // userID
            startDate,
            endDate)
        .$promise.then(function (data) {
            schedules.length = 0;
            schedules.push.apply(schedules, data);
            $scope.isBusy = false;
        }, function () {
            $scope.isBusy = false;
        });
    }

    var resources = classroomSvc.getAllActiveAsync( /* classroomIDtoInclude */ null, /* filterForReservations */ false, /* filterForCourses */ true);
    var schedules = [];

    function newLesson(startDate, endDate) {
        courseDetailDialogPromise.$promise.then(function () {
            courseDetailDialogPromise.$scope.editRecurrence = false;
            courseDetailDialogPromise.$scope.model = courseScheduleSvc.createNewCourse(
                startDate,
                endDate,
                $scope.schedulerSettings.selectedResourceID,
                $scope.semesterID);
            courseDetailDialogPromise.$scope.onSave = function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            };
            courseDetailDialogPromise.show();
        });
    }

    function newRecurrence(startDate, endDate) {
        courseDetailDialogPromise.$promise.then(function () {
            courseDetailDialogPromise.$scope.editRecurrence = true;
            courseDetailDialogPromise.$scope.model = courseScheduleSvc.createNewCourse(
                startDate,
                endDate,
                $scope.schedulerSettings.selectedResourceID,
                $scope.semesterID,
                true);
            courseDetailDialogPromise.$scope.onSave = function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            };
            courseDetailDialogPromise.show();
        });
    }

    function newEvent(startDate, endDate) {
        eventDetailDialogPromise.$promise.then(function () {
            eventDetailDialogPromise.$scope.model = courseScheduleSvc.createNewEvent(
                startDate,
                endDate,
                $scope.schedulerSettings.selectedResourceID,
                $scope.semesterID);
            eventDetailDialogPromise.$scope.hideActionChange = false;
            eventDetailDialogPromise.$scope.onSave = function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            };
            eventDetailDialogPromise.show();
        });
    }

    function changeEvent(event) {
        var current = courseScheduleSvc.getSingle(event.origAction.courseScheduleID);

        $q.all([current.$promise, courseDetailDialogPromise.$promise]).then(
            function () {
            eventDetailDialogPromise.$scope.model = angular.copy(current);
            eventDetailDialogPromise.$scope.hideActionChange = false;
            eventDetailDialogPromise.$scope.onSave = function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            };
            eventDetailDialogPromise.show();
        });
    }

    function changeLesson(lesson) {
        var current = courseScheduleSvc.getSingle(lesson.origAction.courseScheduleID);

        $q.all([current.$promise, courseDetailDialogPromise.$promise]).then(
            function () {
                courseDetailDialogPromise.$scope.editRecurrence = false;
                courseDetailDialogPromise.$scope.model = angular.copy(current);
                courseDetailDialogPromise.$scope.onSave = function () {
                    loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
                };
                courseDetailDialogPromise.show();
            });
    }

    function changeRecurrence(lesson) {
        var pattern = courseScheduleSvc.getPattern(
            lesson.origAction.courseID, lesson.origAction.courseScheduleID);

        $q.all([pattern.$promise, courseDetailDialogPromise.$promise]).then(
            function () {
                courseDetailDialogPromise.$scope.editRecurrence = true;
                courseDetailDialogPromise.$scope.model = angular.copy(pattern);
                courseDetailDialogPromise.$scope.onSave = function () {
                    loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
                };
                courseDetailDialogPromise.show();
            });
    }

    function deleteSingleLessonNoRecurrence(event) {
        courseScheduleSvc.remove(
            event.origAction,
            {
                sendEmailNotification: true,
                sendSmsNotification: false
            },
            function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            }
        );
    }

    function deleteSingleLessonRecurrence(event) {
        courseScheduleSvc.remove(
            event.origAction,
            {
                sendEmailNotification: true,
                sendSmsNotification: false
            },
            function () {
                loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
            }
        );
    }

    function deleteRecurrence(event) {
        
        var pattern = courseScheduleSvc.getPattern(
            event.origAction.courseID, event.origAction.courseScheduleID)
        .$promise.then(function (pattern) {
            courseScheduleSvc.remove(
                pattern,
                {
                    sendEmailNotification: true,
                    sendSmsNotification: false
                },
                function () {
                    loadSemesterSchedule($scope.semesterID, lastStartDate, lastEndDate);
                }
            );
        });
    }

    function deleteEvent(event) {
        if (event.recurrenceType === 0) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRM_DELETE',
                message: 'TXT_TEXT_CONFIRM_DELETE',
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: function () {
                        deleteSingleLessonNoRecurrence(event);
                    }
                }]
            });
        } else {
            // Recurrence
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRM_DELETE_RECURRENCE',
                message: $translate.instant('TXT_TEXT_CONFIRM_DELETE_RECURRENCE').f(event.name),
                buttons: [{
                    text: 'TXT_BTN_CANCEL'
                }, {
                    text: 'TXT_BTN_SERIES',
                    callback: function () {
                        deleteRecurrence(event);
                    }
                }, {
                    text: 'TXT_BTN_THIS_LESSON',
                    callback: function () {
                        deleteSingleLessonRecurrence(event);
                    }
                }]
            });
        }
    }

    $scope.schedulerSettings = {
        weekView: true,
        autoHourRange: false,
        noHeader: true,
        width: '100%',
        visibleResources: 1,
        showRecurrence: true,
        // selectedResourceID: 1,
        startHour: tenantSettingSvc.settings.scheduleVisibleTimeStart,
        endHour: tenantSettingSvc.settings.scheduleVisibleTimeEnd,
        scale: tenantSettingSvc.settings.scheduleTimeScale,
        startDate: lastStartDate,
        resources: resources,
        resourcesMapping: { resourceID: 'id' },
        actions: schedules,
        actionsMapping: {
            resourceID: 'classroomID',
            name: 'subject',
            teacher: 'teacherName',
            filled: 'filledCapacity'
        },
        commands: [{
            text: 'TXT_LBL_NEW_LESSON',
            isVisible: function (event, startDate, endDate) { 
                return !event && securitySvc.isInRole('CourseSchedule.Insert');
            },
            callback: function (event, startDate, endDate) {
                newLesson(startDate, endDate);
            }
        }, {
            text: 'TXT_LBL_NEW_RECURRENCE',
            isVisible: function (event, startDate, endDate) { 
                return !event && securitySvc.isInRole('CourseSchedule.Insert');
            },
            callback: function (event, startDate, endDate) {
                newRecurrence(startDate, endDate);
            }
        }, {
            text: 'TXT_LBL_NEW_EVENT',
            isVisible: function (event, startDate, endDate) {
                return !event && securitySvc.isInRole('CourseSchedule.Insert');
            },
            callback: function (event, startDate, endDate) {
                newEvent(startDate, endDate);
            }
        }, {
            text: 'TXT_MENU_EDIT',
            isVisible: function (event, startDate, endDate) {
                if (!event) {
                    return false;
                }
                
                if (securitySvc.isInRole('CourseSchedule.Update')) {
                    return true;
                }

                if (securitySvc.isInRole('CourseSchedule.UpdateOwn')) {
                    let employee = _.find(employees, {employeeID: event.origAction.employeeID});
                    return employee != null && employee.userID === securitySvc.loggedInUser().userID;
                }
                
                return false;
            },
            callback: function (event, startDate, endDate) {
                if (event.type === 1) {
                    changeLesson(event);
                } else {
                    changeEvent(event);
                }
            }
        }, {
            text: 'TXT_LBL_CHANGE_RECURRENCE',
            isVisible: function (event, startDate, endDate) {
                return !!event && event.recurrenceType !== 0 && securitySvc.isInRole('CourseSchedule.Update');
            },
            callback: function (event, startDate, endDate) {
                changeRecurrence(event);
            }
        }, {
            text: 'TXT_MENU_DELETE',
            isVisible: function (event, startDate, endDate) {
                if (!event) {
                    return false;
                }
                
                if (securitySvc.isInRole('CourseSchedule.Delete')) {
                    return true;
                }
                if (securitySvc.isInRole('CourseSchedule.DeleteOwn')) {
                    let employee = _.find(employees, {employeeID: event.origAction.employeeID});
                    return employee != null && employee.userID === securitySvc.loggedInUser().userID;
                }
                
                return false;
            },
            callback: function (event, startDate, endDate) {
                deleteEvent(event);
            }
        }]
    }

    var eventDetailDialogPromise = $modal({
        templateUrl: 'schedule/schedule-event-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var courseDetailDialogPromise = $modal({
        templateUrl: 'schedule/schedule-course-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);
